import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TeamRemoveUsersDialogComponent } from './team-remove-users-dialog.component';

@NgModule({
  declarations: [TeamRemoveUsersDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [TeamRemoveUsersDialogComponent],
  entryComponents: [TeamRemoveUsersDialogComponent],
})
export class TeamRemoveUsersDialogModule {}
